var render, staticRenderFns
import script from "./grid-table.vue?vue&type=script&lang=js"
export * from "./grid-table.vue?vue&type=script&lang=js"
import style0 from "./grid-table.vue?vue&type=style&index=0&id=f59e7d2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59e7d2c",
  null
  
)

export default component.exports